import ApiService from "@/api/ApiService";
import NewRangePicker from "@/shared/forms/NewRangePicker";
import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import dayjs from "dayjs";
import { forwardRef, useState, useImperativeHandle } from "react";

export default forwardRef(function PartDateSelector({}: {}, ref) {
  const [data, setData] = useState<
    | {
        resourceBookingId: number;
        originDate: string;
        resourceId: number;
        resourceType: "HUMAN" | "RESOURCE" | "CREW" | "NONE";
        startDate: string;
        jobId: number;
        crewId: number;
      }
    | false
  >(false);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const queryClient = useQueryClient();

  const changeMutation = useMutation<any, AxiosResponse, any>({
    mutationFn: ApiService.changeCalendar(),
    onSettled: (answer) => {
      queryClient.invalidateQueries({
        predicate: (query) => {
          if (query.queryKey[0] === "getOpenRequests") {
            console.log("Invalidating query:", query.queryKey);
            return true;
          }

          if (
            query.queryKey[0] === "getCalendar" &&
            query.queryKey[3] >= answer.minWeek &&
            query.queryKey[3] <= answer.maxWeek
          ) {
            console.log("Invalidating query:", query.queryKey);
            return true;
          }

          return false;
        },
      });
      setData(false);
    },
  });

  useImperativeHandle(ref, () => ({
    openModal: (incomingData: typeof data) => {
      if (!incomingData) return;
      setData(incomingData);
      setStartDate(incomingData.startDate);
      setEndDate(incomingData.startDate);
    },
  }));

  return !!data ? (
    <Dialog open={true} maxWidth="sm" onClose={() => setData(false)}>
      <DialogTitle>
        {data.jobId === 0 ? "Eintrag löschen" : "Umdisponieren"}
      </DialogTitle>
      <DialogContent>
        <NewRangePicker
          small
          onChange={([startDate, endDate]) => {
            setStartDate(!!startDate ? startDate.format("YYYY-MM-DD") : null);
            setEndDate(!!endDate ? endDate.format("YYYY-MM-DD") : null);
          }}
          value={[dayjs(startDate, "YYYY-MM-DD"), dayjs(endDate, "YYYY-MM-DD")]}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setData(false)}>Abbrechen</Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={changeMutation.isPending}
          onClick={() => {
            changeMutation.mutate(
              data.resourceBookingId > 0
                ? {
                    partMoveWithRange: {
                      resourceBookingId: data.resourceBookingId,
                      jobId: data.jobId,
                      crewId: data.crewId,
                      startDate,
                      endDate,
                    },
                  }
                : {
                    createBookingWithRange: {
                      resourceId: data.resourceId,
                      jobId: data.jobId,
                      resourceType: data.resourceType,
                      startDate,
                      endDate,
                    },
                  }
            );
          }}
        >
          {data.jobId === 0 ? "Löschen" : "Umdisponieren"}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  ) : null;
});
